import { NEXT_PARAM } from './routes'

/**
 * Leave for the host the API named.
 *
 * `POST /auth/login` and `/auth/signup` on the apex answer with `handoff_url`
 * when the user has a verified default organisation: `https://<its
 * host>/auth/handoff#token=…` (spec: *Sessions and the handoff*). That is a
 * different origin — the session cookie is host-only and the SPA on this host
 * cannot set one for that host — so it is a full navigation, not a router
 * transition. `Handoff` on the far side turns the token into a session there.
 *
 * Returns whether it left, so the caller knows not to adopt an identity the
 * page is about to unload anyway — adopting first would flash the apex's
 * organisation picker for a frame before the browser goes.
 *
 * `window.location.assign` rather than `href =` so a test can replace it:
 * jsdom does not implement navigation and logs an error on a real attempt.
 */
export function followHandoff(url: string | null | undefined, next?: string): boolean {
  if (!url) return false
  window.location.assign(withHandoffNext(url, next))
  return true
}

/**
 * `?next=` on a handoff URL, before its fragment.
 *
 * The token travels in the fragment and the destination in the query, so the
 * far host's `Handoff` reads one from each: `https://acme…/auth/handoff?next=
 * %2Fonboarding#token=…`. Same-origin paths only — `Handoff` runs `safeNext`
 * over it — and a caller with nothing to say leaves the URL as the API built it.
 */
export function withHandoffNext(url: string, next?: string): string {
  if (!next) return url
  const target = new URL(url)
  target.searchParams.set(NEXT_PARAM, next)
  return target.toString()
}
